import { useMemo } from 'react';

import isEmpty from 'lodash/isEmpty';

import { getCurrentContentTitle, getCurrentContentFeedKeys } from '@lumapps/contents/ducks/selectors';
import { useWatch } from '@lumapps/lumx-forms';
import { useSelector } from '@lumapps/redux/react';

import { CONTENT_PROPERTIES_NAMES } from '../constants';

export const useContentValidity = () => {
    let titleObject;
    let feedKeys;
    const legacyTitleObject = useSelector(getCurrentContentTitle);

    const legacyFeedKeys = useSelector(getCurrentContentFeedKeys);

    try {
        [titleObject, feedKeys] = useWatch({
            name: [CONTENT_PROPERTIES_NAMES.TITLE, CONTENT_PROPERTIES_NAMES.VISIBLE_BY],
        });
    } catch (error) {
        titleObject = legacyTitleObject;
        feedKeys = legacyFeedKeys;
    }

    const isValid = useMemo(() => {
        if (!titleObject || isEmpty(titleObject)) {
            return false;
        }

        if (!feedKeys || isEmpty(feedKeys)) {
            return false;
        }

        return true;
    }, [feedKeys, titleObject]);

    return isValid;
};
